import React, { useEffect } from 'react';
import {
	IonPage,
	IonContent,
	IonHeader,
	IonToolbar,
	IonTitle,
	IonButton,
	IonGrid,
	IonRow,
	IonCol,
	IonText,
	IonIcon,
	IonImg,
	IonButtons,
	IonBadge
} from '@ionic/react';
import { enter, exit, logoFacebook } from 'ionicons/icons';
import { _defaultButtonColor, _dict } from '../components/constants';
import { useGlobalStore } from '../components/stateManagement/globalZustand';
import { useHistory } from 'react-router';
import { useUserStore } from '../components/stateManagement/userZustand';
import YouTube, { YouTubeProps } from 'react-youtube';
import { logMe } from '../foo/user';
import FeedbackForm from './FeedbackForm';
import './LandingPage.css'

function Video(props: { which: string }) {
	let videoId = "";
	
	const onPlayerReady: YouTubeProps['onReady'] = (event) => {
	  // access to player in all event handlers via event.target
	  event.target.pauseVideo();
	}
  
	const opts: YouTubeProps['opts'] = {
	  height: '390',
	  width: '640',
	  playerVars: {
		// https://developers.google.com/youtube/player_parameters
		autoplay: 0,
	  },
	};
	
	if(props.which === "1"){
		videoId="AJ7EkauSTdI";
	}else if(props.which === "2"){
		videoId="vSKYPiQ2dmk";
	}else if(props.which === "3"){
		videoId="mm-uoExq6PA";
	}
	return <YouTube
	videoId={videoId}
	opts={opts}
	onReady={onPlayerReady}
	onPlay={(event) => {
		logMe("landingPage-play-video-"+props.which);
	}}
	 />;
}

interface LandingPageProps { }

const LandingPage: React.FC<LandingPageProps> = () => {
	const { lang } = useGlobalStore();
	const { hasLoggedIn, userEmail } = useUserStore();
	const [ clickedOption, setClickedOption ] = React.useState<string | null>(null);
	const history = useHistory();

	const loginButton = <IonButton size="large" expand="block" style={{ "--background": _defaultButtonColor, "--color": "white" }} onClick={() => history.push("/login")}><IonIcon icon={enter} />{_dict.login[lang]}</IonButton>;
	const logoutButton = <IonButton size="large" expand="block" style={{ "--background": _defaultButtonColor, "--color": "white" }} onClick={() => history.push("/logout")}>{_dict.logout[lang]}<IonIcon icon={exit} /></IonButton>;
	const pricingButton = <IonButton expand="block"
	size='large'
	style={{ "--background": _defaultButtonColor, "--color": "white" }} onClick={() => history.push("/pricing")}>{_dict.startFreeMsg[lang]}
	</IonButton>;
	
	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonTitle>
						<span style={{ color: _defaultButtonColor, fontSize: '1.4rem', fontWeight: 'bold' }}>{_dict.LPwelcomeMsg[lang]}</span>
					</IonTitle>
					<IonButtons slot="end">
						{hasLoggedIn === true && <IonBadge color="light">{_dict.hello[lang]} {userEmail}</IonBadge>}
						{hasLoggedIn !== true ? loginButton : logoutButton}
					</IonButtons>
				</IonToolbar>
			</IonHeader>

			<IonContent className="ion-padding">
				
				<IonGrid >
					<IonRow>
						<IonCol offset="2" size="8" className="ion-text-center">
							<img

							style={{"borderRadius": "15px"}}
							src={`assets/hero_${lang}.png`}
							alt="Hero Image Showing App Interface"
							/>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol>
							<p>{_dict.customizeContentMsg[lang]}</p>
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol className="need-header">
							{_dict.whatDoYouNeed[lang]}
						</IonCol>
					</IonRow>
					<IonRow>
						<IonCol
						 
						 style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexDirection:"column" }}>
						
								<IonButton onClick={() => {
									setClickedOption("1");
									logMe("landingPage-click-opt-1")
								}} color={clickedOption==="1" ? "dark" : "light"} size='large'>
									{_dict.generatManyExercisesFast[lang]}
								</IonButton>
								{clickedOption==="1" && <Video which="1" />}
								<IonButton onClick={() => {
									setClickedOption("2");
									logMe("landingPage-click-opt-2");
								}} color={clickedOption==="2" ? "dark" : "light"} size='large'>
									{_dict.convertTextToCardsWithCopyPaste[lang]}
								</IonButton>
								{clickedOption==="2" && <Video which="2" />}
								<IonButton onClick={() => {
									setClickedOption("3");
									logMe("landingPage-click-opt-3");
								}} color={clickedOption==="3" ? "dark" : "light"} size='large'>
									{_dict.customizeCardsAndExportToPDF[lang]}
								</IonButton>
								{clickedOption==="3" && <Video which="3" />}
								<IonButton onClick={() => {
									setClickedOption("4");
									logMe("landingPage-click-opt-4");
								}} color={clickedOption==="4" ? "dark" : "light"} size='large'>
									{_dict.other[lang]}...
								</IonButton>
								{clickedOption==="4" && 
									<FeedbackForm />
								}
								
						</IonCol>
					</IonRow>
					{/*<IonRow>
						<IonCol size="12">
							<IonText style={{ color: _defaultButtonColor }}>
								<h2>{_dict.optimizeTimeMsg[lang]}</h2>
							</IonText>
							<p>{_dict.reducePrepTimeMsg[lang]}</p>
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol size="12">
							<IonText style={{ color: _defaultButtonColor }}>
								<h2>{_dict.accessibleEverywhereMsg[lang]}</h2>
							</IonText>
							<p>{_dict.accessibleOnDevicesMsg[lang]}</p>
							<p>{_dict.exportPDFShareMsg[lang]}</p>
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol size="12">
							<IonText style={{ color: _defaultButtonColor }}>
								<h2>{_dict.tailoredLearningMsg[lang]}</h2>
							</IonText>
							<p>{_dict.customizeMaterialsMsg[lang]}</p>
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol size="12">
							<IonText style={{ color: _defaultButtonColor }}>
								<h2>{_dict.DSAPPInAction[lang]}</h2>
							</IonText>
							
						</IonCol>
					</IonRow>

					<IonRow>
						<IonCol size="12">
							<IonText style={{ color: _defaultButtonColor }}>
								<h2>{_dict.ifYouAreUnsatisfied[lang]}</h2>
							</IonText>
							<p>{_dict.ifYouAreUnsatisfiedMessage[lang]}</p>
							<p><IonButton color="light" onClick={() => { window.location.href = "https://www.facebook.com/dsapp.comunicare" }}>
								<IonIcon icon={logoFacebook} />
							</IonButton></p>

						</IonCol>
					</IonRow>*/}

					<IonRow>
						<IonCol size="12">{pricingButton}</IonCol>

					</IonRow>
				</IonGrid>
			</IonContent>
		</IonPage>
	);
};

export default LandingPage;
